'use strict';

const jQuery = require('jquery');

const getBackgroundColor = function($content) {
    if ($content.css('background-color') === 'rgba(0, 0, 0, 0)') {
        let $cloudContentSet = $content.parents('.cloudcontentset');

        if ($cloudContentSet.css('background-image') === undefined && $cloudContentSet.css('background-color') === undefined) {
            let color = $cloudContentSet.css('background-color');
            if (color === undefined) {
                color = '#fff';
            } else {
                color = jQuery('#bb-site-wrapper').css('background-color');
            }

            $content.css('background-color', color);
        }
    }
};

module.exports.start = function($content) {
    $content.addClass('highlight-content');

    getBackgroundColor($content);
};

module.exports.stop = function($content) {
    $content.removeClass('highlight-content');
};
